export function loadPrivacyPolicyContent(language: string): string {
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return require(`@/data/privacyPolicy/${language}.json`)
  } catch {
    return ''
  }
}

export function loadTermsOfUseContent(language: string): string {
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return require(`@/data/termsOfUse/${language}.json`)
  } catch {
    return ''
  }
}

export function loadCookiePolicyContent(language: string): string {
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return require(`@/data/cookiePolicy/${language}.json`)
  } catch {
    return ''
  }
}
